import { render, staticRenderFns } from "./FullOfferMarketsStandard.vue?vue&type=template&id=770ef258&scoped=true"
import script from "./FullOfferMarketsStandard.vue?vue&type=script&lang=js"
export * from "./FullOfferMarketsStandard.vue?vue&type=script&lang=js"
import style0 from "./FullOfferMarketsStandard.vue?vue&type=style&index=0&id=770ef258&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "770ef258",
  null
  
)

export default component.exports